import { useEffect } from "react";
import { useRouter } from "next/router";

import { useHalloween2026 } from "@/hooks/useHalloween2026";
import { isCheckoutRoute } from "@/hooks/useWelcomeCouponOffer";
import { mountCursorCompanion } from "@/libs/halloween-2026/cursor-companion";

/**
 * 할로윈 2026 커서 컴패니언 (#6061 H3) — 기간 중 데스크톱 마우스 커서 옆에 유령이 따라붙는다.
 *
 * 범위: 결제 화면과 앱 임베드(`/webview` · `/webview-pcp`)를 뺀 전 페이지.
 * - 결제 중 커서 장식은 입력을 방해한다(신규 가입 쿠폰 배지와 같은 제외 판정).
 * - 앱 임베드는 웹사이트 이벤트 장식이 앱 UI 에 나오는 자리다 — PC Player(`webview-pcp`)는 마우스 환경이라
 *   데스크톱 조건을 통과한다(#6066 R1). 판정은 `GlobalEScripts` 와 같은 세그먼트 규칙.
 * Figma 스펙의 적용 범위는 기획 미정(TBD)이라 바뀌면 여기만 고친다.
 *
 * 그리는 것은 DOM 레이어 하나다(`mountCursorCompanion`) — 매 프레임 위치를 React 상태로 돌리지 않는다.
 */
/** 앱 임베드 화면 — 세그먼트가 `webview` 로 시작하면(`webview-pcp` 포함). `GlobalEScripts` 와 같은 규칙. */
export const isAppEmbedRoute = (pathname: string): boolean =>
  pathname.split("/").some((seg) => seg.startsWith("webview"));

export function Halloween2026Cursor() {
  const active = useHalloween2026();
  const { pathname } = useRouter();
  const enabled =
    active && !isCheckoutRoute(pathname) && !isAppEmbedRoute(pathname);

  useEffect(() => {
    if (!enabled) return;
    return mountCursorCompanion(document.body);
  }, [enabled]);

  return null;
}
